import { globalWindow } from "@/lib/ssr-utils";
import type { UserToken } from "@/lib/token";

export type GTMEvent = {
  event?: string;
  ecommerce?: Record<string, unknown> | null;
} & Record<string, unknown>;

export interface DataLayer extends Array<GTMEvent> {
  push(...items: GTMEvent[]): number;
}

declare global {
  interface Window {
    dataLayer: DataLayer;
  }
}

export const dataLayer: () => DataLayer = () =>
  globalWindow ? (globalWindow.dataLayer = globalWindow.dataLayer ?? []) : [];

export const pushLoggedInInformation = (me: UserToken | undefined) =>
  dataLayer().push({ loggedIn: !!me, userRole: me?.role ?? "nobody" });
